export default class Route {
    static LOGIN = {
        name: 'login',
        path: '/login',
    };

    static SEARCH = {
        name: 'search',
        path: '/search-customer',
        neededRoles: ['Leserservice', 'Leserservice-Leitung', 'Admin', 'Developer'],
    };

    static DEVTOOL = {
        name: 'devtool',
        path: '/devtool',
        neededRoles: ['Developer'],
    };

    static CUSTOMER_C1 = {
        name: 'customer_c1',
        path: '/customer/:sso_id',
        neededRoles: ['Leserservice', 'Leserservice-Leitung', 'Admin', 'Developer'],
    };

    static CUSTOMER_MSP = {
        name: 'customer_MSP',
        path: '/customer/msp/:gp_id/:scope',
        neededRoles: ['Leserservice', 'Leserservice-Leitung', 'Admin', 'Developer'],
    };

    static CUSTOMER_CREATE = {
        name: 'customer_create',
        path: '/customer/create',
        neededRoles: ['Leserservice-Leitung', 'Admin', 'Developer'],
    };

    static CUSTOMER_EDIT_EMAIL = {
        name: 'customer_edit_email',
        path: '/customer/edit/email/:sso_id',
        neededRoles: ['Leserservice', 'Leserservice-Leitung', 'Admin', 'Developer'],
    };

    static CUSTOMER_LINKED_ACCOUNTS = {
        name: 'customer_linked_accounts',
        path: '/customer/:sso_id/linked_accounts',
        neededRoles: ['Leserservice', 'Leserservice-Leitung', 'Admin', 'Developer'],
    };

    static APPLICATIONS = {
        name: 'applications',
        path: '/applications',
        neededRoles: ['Developer'],
    };

    static APPLICATION_PERMISSIONS = {
        name: 'application_permissions',
        path: '/application/permissions',
        neededRoles: ['Admin', 'Developer'],
    };

    static SALESFORCE = {
        name: 'salesforce',
        path: '/salesforce',
        neededRoles: ['Developer'],
    };
}
